import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M4.107 4.108C5.67 2.545 7.79 1.667 10 1.667s4.33.878 5.892 2.44C17.455 5.67 18.333 7.79 18.333 10c0 1.094-.215 2.178-.634 3.19-.419 1.01-1.033 1.929-1.807 2.703-.773.773-1.692 1.387-2.703 1.806-1.011.419-2.095.634-3.19.634-1.094 0-2.177-.215-3.188-.634-1.011-.419-1.93-1.033-2.704-1.806-.774-.774-1.387-1.693-1.806-2.704-.419-1.01-.635-2.095-.635-3.189 0-2.21.878-4.33 2.441-5.892zm3.81 4.225c0-.46.373-.833.833-.833H10c.46 0 .833.373.833.833v5h.833c.46 0 .834.373.834.834 0 .46-.373.833-.834.833H8.333c-.46 0-.833-.373-.833-.833 0-.46.373-.834.833-.834h.833V9.167H8.75c-.46 0-.833-.373-.833-.834zM10 6.667c.46 0 .833-.373.833-.834 0-.46-.373-.833-.833-.833-.46 0-.834.373-.834.833 0 .46.374.834.834.834z",
  "clip-rule": "evenodd"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}